module.exports = __webpack_public_path__ + "static/media/aircall-icon.174de757.svg";